import React from "react";
import logo from "../../../src/Assets/logo.png";
import { BsArrowRightCircle } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import { IoLocationSharp } from "react-icons/io5";
import { FaPhone } from "react-icons/fa6";
import { HiOutlineMail } from "react-icons/hi";
import { TiSocialFacebook } from "react-icons/ti";
import { FaYoutube } from "react-icons/fa";
import { FaInstagramSquare } from "react-icons/fa";
import { FaLinkedinIn } from "react-icons/fa6";

export default function DemoFooter() {
  const links = [
    { name: "Home", path: "/" },
    { name: "About Us", path: "/about" },
    { name: "Our Products", path: "/products" },
    { name: "Blog", path: "/blog" },
    { name: "Gallery", path: "/gallery" },
    { name: "Corporate", path: "/corporate" },
    { name: "Carrier", path: "/carrier" },
    { name: "Contact", path: "/contact" },
  ];

  const category = [
    { name: "Micronutrients" },
    { name: "Water Soluble Fertlizers" },
    { name: "Bio- Pesticides & Larvicides" },
    { name: "Plant growth Regulators" },
    { name: "Bio Fertilisers & Organic Fertilisers" },
  ];

  const touch = [
    {
      icon: <IoLocationSharp size={17} className="mt-1" />,
      name: "PLOT NO- 5/1,5/2, KHOLADWARA INDUSTRIAL ESTATE, Jatni, Khordha, Odisha 752057",
    },
    { icon: <FaPhone className="mt-1" />, name: "+91 98539 32961" },
    {
      icon: <HiOutlineMail className="mt-1" />,
      name: "support@kalingabio.com",
    },
  ];

  const navigate = useNavigate();

  return (
    <footer className="w-full px-4 sm:px-6 md:px-10 py-4 sm:py-8 bg-[#232323]">
      <div className="flex flex-col sm:flex-row gap-5 justify-between items-center bg-[#FFFFFF05] p-2 rounded-lg">
        <div className="flex gap-3">
          <img src={logo} alt="logo" className="h-20 w-20" />
          <div className="flex flex-col text-xl font-serif text-[#CACACA] mt-2">
            <span>Kalinga Bio Ferti Chem</span>
            <span>Private Limited</span>
          </div>
        </div>
        <div className="flex flex-col text-sm gap-2">
          <span className="text-[#92AD36] text-center">Call Us On</span>
          <span className="text-[#FFFFFF]">+91 98539 32961</span>
        </div>
        <div className="flex">
          <input
            type="email"
            placeholder="Enter email here"
            className="px-2 py-3 rounded-l-full bg-white outline-none"
          />
          <button className="text white bg-[#2B6200] rounded-r-full px-4 py-3 text-sm text-white">
            Subscribe
          </button>
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 lg-grid-cols-4 w-full mt-14 gap-10 items-start">
        <div className="flex flex-col w-full">
          <div className="flex gap-3">
            <span className="h-[25px] w-2  bg-[#92AD36]"></span>
            <p className="text-white font-serif text-xl">About KalingaBio</p>
          </div>
          <p className="text-sm text-white/70 mt-6 leading-relaxed tracking-wide">
            Agrotek is bundled Html Template for who is passionate about farming
            and agriculture, gardening services related websites.
          </p>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3745.054014926053!2d85.65296277500711!3d20.173476381270408!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a19aebe60376915%3A0x5ca52f87c1f12f54!2sKALINGA%20BIO%20FERTI-CHEM%20PRIVATE%20LIMITED!5e0!3m2!1sen!2sin!4v1774604305554!5m2!1sen!2sin"
            width="100%"
            height="250"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            className="mt-4 rounded-lg"
          />
          <div className="flex gap-3 mt-4 text-white">
            <p className=" font-medium text-base">Find Us On Map</p>
            <span>
              <BsArrowRightCircle size={15} className="mt-2" />
            </span>
          </div>
        </div>
        <div className="flex flex-col w-full">
          <div className="flex gap-3">
            <span className="h-[25px] w-2  bg-[#92AD36]"></span>
            <p className="text-white font-serif text-xl">Useful Links</p>
          </div>
          <ul className="space-y-5 mt-6">
            {links.map((item, index) => (
              <li
                key={index}
                onClick={() => navigate(item.path)}
                className="flex items-center gap-3 text-white hover:text-[#92AD36] cursor-pointer transition"
              >
                <span className="inline-block w-2 h-2 bg-[#92AD36]"></span>
                {item.name}
              </li>
            ))}
          </ul>
        </div>
        <div className="flex flex-col w-full">
          <div className="flex gap-3">
            <span className="h-[25px] w-2  bg-[#92AD36]"></span>
            <p className="text-white font-serif text-xl">Category</p>
          </div>
          {category.map((item, index) => (
            <div
              onClick={() => navigate("/products")}
              key={index}
              className="flex items-center mt-6"
            >
              <div className="rounded-xl text-[#DDDDDD] w-full border p-3 text-sm border-[#DDDDDD]">
                <span className="line-clamp-1">{item.name}</span>
              </div>
            </div>
          ))}
        </div>
        <div className="flex flex-col w-full">
          <div className="flex gap-3">
            <span className="h-[25px] w-2  bg-[#92AD36]"></span>
            <p className="text-white font-serif text-xl">Get In Touch</p>
          </div>
          <div className="mt-6 flex flex-col space-y-10">
            {touch.map((item, index) => (
              <div key={index} className="flex gap-4 text-white/70">
                <span>{item.icon}</span>
                <span className="text-sm">{item.name}</span>
              </div>
            ))}
            <div className="flex items-center space-x-5">
              <TiSocialFacebook size={20} className="text-[#FFFFFF]" />
              <FaYoutube size={16} className="text-[#FFFFFF]" />
              <FaInstagramSquare size={16} className="text-[#FFFFFF]" />
              <FaLinkedinIn size={16} className="text-[#FFFFFF]" />
            </div>
          </div>
          <button
            onClick={() => navigate("/login")}
            className="px-5 py-2 bg-[#92AD36] text-white text-sm rounded-lg mt-5 w-1/2"
          >
            Admin Login
          </button>
        </div>
      </div>
      <div className="w-full text-white mt-6 leading-relaxed tracking-wide">
        <p className="text-center text-xs md:text-sm">
          Copyright © 2026{" "}
          <span className="font-semibold text-gray-400">KalingaBio</span>{" "}
          Designed by{" "}
          <span className="font-semibold text-gray-400 hover:underline cursor-pointer">
            WebBocket Software Pvt. Ltd.
          </span>
        </p>
      </div>
    </footer>
  );
}
